/** @file index.js
  * @brief Registers the app into the html page
  *
  * @author Justin Eslinger - Fivestone Studios
  * @date 07/23/2020
  *
  */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

/**
 * Renders the application to the root id on the html page
 */
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
